// https://github.com/cookpete/react-player/blob/master/src/patterns.js

/**
 * Regex patterns for player sources
 */
export const MATCH_URL_YOUTUBE =
  /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:embed\/|v\/|watch\/|watch\?v=|watch\?.+&v=))((\w|-){11})|youtube\.com\/playlist\?list=|youtube\.com\/user\//;
export const MATCH_URL_KALTURA =
  /^https?:\/\/[a-zA-Z]+\.kaltura.(com|org)\/p\/([0-9]+)\/sp\/([0-9]+)00\/embedIframeJs\/uiconf_id\/([0-9]+)\/partner_id\/([0-9]+)(.*)entry_id.([a-zA-Z0-9-_]+)$/;
export const AUDIO_EXTENSIONS =
  /\.(m4a|m4b|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
export const VIDEO_EXTENSIONS =
  /\.(mp4|og[gv]|webm|mov|m4v)(#t=[,\d+]+)?($|\?)/i;
export const HLS_EXTENSIONS = /\.(m3u8)($|\?)/i;
export const DASH_EXTENSIONS = /\.(mpd)($|\?)/i;
export const FLV_EXTENSIONS = /\.(flv)($|\?)/i;

export function isMediaStream(url: unknown): url is MediaStream {
  return (
    typeof window !== "undefined" &&
    typeof MediaStream !== "undefined" &&
    url instanceof MediaStream
  );
}

export function isBlobUrl(url: string) {
  return /^blob:/.test(url);
}

const canPlayFile = (
  url: string | MediaStream | Array<string | { src: string }>
) => {
  if (url instanceof Array) {
    for (const item of url) {
      if (typeof item === "string" && canPlayFile(item)) {
        return true;
      }
      if (typeof item !== "string" && canPlayFile(item.src)) {
        return true;
      }
    }
    return false;
  }
  if (isMediaStream(url) || (typeof url === "string" && isBlobUrl(url))) {
    return true;
  }
  return (
    AUDIO_EXTENSIONS.test(url) ||
    VIDEO_EXTENSIONS.test(url) ||
    HLS_EXTENSIONS.test(url) ||
    DASH_EXTENSIONS.test(url) ||
    FLV_EXTENSIONS.test(url)
  );
};

/**
 * Function that checks the validity of the url based
 * on regex patterns
 * @param url {String}
 * @returns
 */
export const canPlay = {
  youtube: (url: string | string[]) => {
    if (url instanceof Array) {
      return url.every((item) => MATCH_URL_YOUTUBE.test(item));
    }
    return MATCH_URL_YOUTUBE.test(url);
  },
  kaltura: (url: string) => MATCH_URL_KALTURA.test(url),
  file: canPlayFile,
};
